/**
 * Henry & Co — light behavioural layer.
 * Everything here is progressive enhancement; the theme works without JS.
 */
(function () {
  'use strict';

  /* Quantity steppers: <div class="qty"><button data-step="-1">…<input>…<button data-step="1"></div> */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.qty button[data-step]');
    if (!button) return;
    var input = button.closest('.qty').querySelector('input');
    var step = parseInt(button.dataset.step, 10);
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    input.value = Math.max(min, value + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* PDP gallery: thumbnails swap the main image */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    event.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    if (!main) return;
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  /* Sticky nav shadow once it sticks */
  var nav = document.querySelector('[data-sticky-nav]');
  if (nav && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    nav.parentNode.insertBefore(sentinel, nav);
    new IntersectionObserver(function (entries) {
      nav.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /*
   * Complementary products via the Product Recommendations API.
   *
   * The section ships hidden with its heading inside the fetched fragment, so
   * a product with nothing picked in Search & Discovery never shows a lone
   * title: we reveal it only once products actually come back, and a failed
   * request leaves it hidden rather than stranded. In the theme editor the
   * section always stays put, or it couldn't be selected.
   */
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-recommendations-url]').forEach(function (holder) {
    var wrapper = holder.closest('[data-recommendations-section]');

    function hide() {
      if (designMode) return;
      if (wrapper) {
        wrapper.hidden = true;
        return;
      }
      var section = holder.closest('.shopify-section');
      if (section) section.style.display = 'none';
    }

    fetch(holder.dataset.recommendationsUrl)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var inner = html.querySelector('[data-recommendations-content]');
        if (inner && inner.children.length > 0) {
          holder.innerHTML = inner.innerHTML;
          if (wrapper) wrapper.hidden = false;
        } else {
          hide();
        }
      })
      .catch(hide);
  });

  /* ------------------------------------------------------------------ */
  /* Cart drawer: AJAX add, qty changes, re-render via Section Rendering */
  /* ------------------------------------------------------------------ */
  var drawer = document.querySelector('[data-cart-drawer]');

  function refreshCartDrawer(openAfter) {
    if (!drawer) return Promise.resolve();
    drawer.classList.add('is-loading');
    return fetch(drawer.dataset.sectionUrl)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var fresh = html.querySelector('[data-cart-drawer-content]');
        var current = drawer.querySelector('[data-cart-drawer-content]');
        if (fresh && current) {
          current.replaceWith(fresh);
          var count = fresh.dataset.cartCountValue;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = count > 0 ? count : '';
          });
        }
        if (openAfter) openCartDrawer();
      })
      .finally(function () { drawer.classList.remove('is-loading'); });
  }

  function openCartDrawer() {
    if (drawer && !drawer.open) drawer.showModal();
  }

  function closeCartDrawer() {
    if (drawer && drawer.open) drawer.close();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openCartDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      closeCartDrawer();
      return;
    }
    /* Click on the backdrop (the dialog itself, outside the panel) closes */
    if (drawer && event.target === drawer) closeCartDrawer();
  });

  function changeCartLine(line, quantity) {
    if (!drawer) return;
    drawer.classList.add('is-loading');
    fetch(drawer.dataset.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { refreshCartDrawer(false); });
  }

  document.addEventListener('click', function (event) {
    var stepButton = event.target.closest('[data-cart-qty]');
    if (stepButton) {
      var input = stepButton.closest('.qty').querySelector('input');
      var next = (parseInt(input.value, 10) || 0) + parseInt(stepButton.dataset.step, 10);
      changeCartLine(parseInt(stepButton.dataset.line, 10), Math.max(0, next));
      return;
    }
    var removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      changeCartLine(parseInt(removeButton.dataset.line, 10), 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    changeCartLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* Intercept add-to-cart forms (PDP + card quick add) → AJAX + open drawer */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!drawer) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();

    /* The PDP's sticky bar button lives outside the form and points at it with
       the form attribute, so it has to be locked out of a double add too. */
    var buttons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    if (form.id) {
      buttons = buttons.concat(Array.prototype.slice.call(
        document.querySelectorAll('[type="submit"][form="' + form.id + '"]')
      ));
    }
    buttons.forEach(function (button) { button.disabled = true; });

    fetch(drawer.dataset.cartAddUrl + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return refreshCartDrawer(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        buttons.forEach(function (button) { button.disabled = false; });
      });
  });

  /* PDP sticky add to bag — mirrors the buy box once it has scrolled away */
  function syncStickyAtc(variant, priceText) {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;

    var button = sticky.querySelector('[data-sticky-submit]');

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = 'Unavailable';
      }
      return;
    }

    var price = sticky.querySelector('[data-sticky-price]');
    var name = sticky.querySelector('[data-sticky-variant]');
    if (price) price.textContent = priceText;
    if (name) name.textContent = variant.title;
    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
  }

  /* PDP variant picker: match selected options to a variant, sync id/price/state */
  document.querySelectorAll('[data-product-form]').forEach(function (holder) {
    var jsonEl = holder.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (error) { return; }

    var moneyFormat = function (cents) {
      var priceEl = holder.querySelector('[data-price]');
      var sample = priceEl ? priceEl.textContent.trim() : '£0.00';
      var symbol = sample.replace(/[\d.,\s]/g, '').charAt(0) || '£';
      return symbol + (cents / 100).toFixed(2);
    };

    holder.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        var fieldsets = holder.querySelectorAll('.pdp__option');
        fieldsets.forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          selected.push(checked ? checked.value : null);
        });

        var variant = product.variants.find(function (candidate) {
          return selected.every(function (value, index) {
            return value === null || candidate.options[index] === value;
          });
        });

        var idInput = holder.querySelector('[data-variant-id]');
        var button = holder.querySelector('[data-add-to-cart]');
        var priceEl = holder.querySelector('[data-price]');
        var priceButton = holder.querySelector('[data-price-button]');

        if (!variant) {
          if (button) {
            button.disabled = true;
            button.textContent = 'Unavailable';
          }
          syncStickyAtc(null);
          return;
        }

        syncStickyAtc(variant, moneyFormat(variant.price));

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = moneyFormat(variant.price);
        if (button) {
          button.disabled = !variant.available;
          if (variant.available) {
            button.innerHTML = 'Add to bag — <span data-price-button>' + moneyFormat(variant.price) + '</span>';
          } else {
            button.textContent = 'Sold out';
          }
        }
      });
    });
  });

  /* Reveal the sticky bar once the real Add to bag button has left the top of
     the viewport. The `top < 0` test matters on phones, where the buy box sits
     below the gallery: without it the bar would be up on page load, before the
     button has ever been seen. Without IntersectionObserver the bar simply
     never appears — the buy box itself is untouched. */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var stickyAnchor = document.querySelector('.pdp [data-add-to-cart]');

  if (stickyAtc && stickyAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyAtc.classList.toggle('is-visible', scrolledPast);
    }).observe(stickyAnchor);
  }

  /* Mobile filter drawer — same <dialog> pattern as the cart drawer.
     Only ever opens below 990px; above that the rail is already in view. */
  var filterDrawer = document.querySelector('[data-filter-drawer]');

  /* True only while the drawer is genuinely a modal panel. Everything that
     auto-submits checks this: inside the drawer a tap must NOT reload the
     page, or the panel slams shut on every choice. Changes batch up and the
     Apply button submits them together. */
  function filtersAreBatched() {
    return !!filterDrawer && filterDrawer.open;
  }

  if (filterDrawer) {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-filter-open]')) {
        filterDrawer.showModal();
        return;
      }

      if (event.target.closest('[data-filter-close]')) {
        filterDrawer.close();
        return;
      }

      /* Backdrop click (the dialog itself, outside the panel) closes */
      if (event.target === filterDrawer) filterDrawer.close();
    });

    /* Rotating the phone to landscape can cross the breakpoint while the
       drawer is open, which would leave a fixed panel over a page that now
       has its rail back. */
    window.matchMedia('(min-width: 991px)').addEventListener('change', function (event) {
      if (event.matches && filterDrawer.open) filterDrawer.close();
    });
  }

  /* Price: four bands matching the mega menu, over a dual-thumb slider.
     The slider's two inputs carry the real filter params; the band radios
     are a convenience layer that just moves them. */
  document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
    var minInput = slider.querySelector('[data-price-min]');
    var maxInput = slider.querySelector('[data-price-max]');
    var fill = slider.querySelector('[data-price-fill]');
    var readout = slider.querySelector('[data-price-readout]');
    var ceil = parseFloat(slider.dataset.priceCeil) || 0;
    var group = slider.closest('.plp__filter-price');
    var bands = group ? group.querySelectorAll('[data-price-band]') : [];

    if (!minInput || !maxInput || !ceil) return;

    /* Currency comes from the rendered readout, so this follows the store's
       format rather than hardcoding a pound sign */
    var sample = readout ? readout.textContent.trim() : '';
    var symbol = sample.replace(/[\d.,\s–-]/g, '').charAt(0) || '';

    function money(value) {
      return symbol + (value % 1 === 0 ? value : value.toFixed(2));
    }

    function paint() {
      var low = parseFloat(minInput.value);
      var high = parseFloat(maxInput.value);
      if (fill) {
        fill.style.setProperty('--fill-start', (low / ceil) * 100 + '%');
        fill.style.setProperty('--fill-end', 100 - (high / ceil) * 100 + '%');
      }
      if (readout) readout.textContent = money(low) + ' – ' + money(high);
    }

    /* Thumbs must not cross — whichever is being dragged pushes the other */
    minInput.addEventListener('input', function () {
      if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
        minInput.value = maxInput.value;
      }
      clearBands();
      paint();
    });

    maxInput.addEventListener('input', function () {
      if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
        maxInput.value = minInput.value;
      }
      clearBands();
      paint();
    });

    function clearBands() {
      Array.prototype.forEach.call(bands, function (band) {
        band.checked = false;
      });
    }

    Array.prototype.forEach.call(bands, function (band) {
      band.addEventListener('change', function () {
        if (!band.checked) return;
        minInput.value = band.dataset.bandMin;
        maxInput.value = Math.min(parseFloat(band.dataset.bandMax), ceil);
        paint();
        /* A band is a decision, so it behaves like any other filter choice:
           applies at once on desktop, waits for Apply inside the drawer */
        var form = band.closest('[data-filter-form]');
        if (form && !filtersAreBatched()) submitFilterForm(form);
      });
    });

    paint();
  });

  /* An untouched slider still submits its value, which would pin a price
     filter onto every request. Drop both inputs when they span the full
     range, and never submit the band radios — they are UI, not parameters. */
  function submitFilterForm(form) {
    form.querySelectorAll('[data-price-band]').forEach(function (band) {
      band.disabled = true;
    });

    form.querySelectorAll('[data-price-slider]').forEach(function (slider) {
      var minInput = slider.querySelector('[data-price-min]');
      var maxInput = slider.querySelector('[data-price-max]');
      var ceil = parseFloat(slider.dataset.priceCeil) || 0;
      if (!minInput || !maxInput) return;
      if (parseFloat(minInput.value) <= 0 && parseFloat(maxInput.value) >= ceil) {
        minInput.disabled = true;
        maxInput.disabled = true;
      }
    });

    form.submit();
  }

  /* Collection filters: submit on change (Apply button covers no-JS, and the
     drawer's own Apply covers the batched mobile case) */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    /* The Apply button is a real submit, which bypasses submitFilterForm —
       so do the same tidy-up on the way out */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitFilterForm(form);
    });
  });

  /* Range inputs fire `change` when the thumb is released, so a drag applies
     once on let-go rather than on every pixel.

     Delegated from the document rather than bound to the form: the sort select
     lives out in the results column and is tied to the form by its `form`
     attribute, and form association does not move events — a change out there
     never bubbles through the form element. `target.form` reads the same
     association the browser will use when it submits. */
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field.matches('input[type="checkbox"], input[type="range"], select[name="sort_by"]')) return;
    var form = field.form;
    if (!form || !form.hasAttribute('data-filter-form')) return;
    if (filtersAreBatched()) return;
    submitFilterForm(form);
  });

  /* Full-screen mobile panels — the hamburger menu and the per-category
     panels behind each nav label. Same <dialog> pattern as the cart drawer.
     Without JS the buttons simply do nothing: the category label still links
     to its collection and the panel links are all reachable from the footer,
     so nothing is lost. */
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  function openPanel(panel) {
    if (!panel || panel.open) return;
    /* Only one full-screen panel at a time — showModal() on a second dialog
       would stack it over the first and leave the first unreachable. */
    document.querySelectorAll('dialog[data-mobile-menu][open], dialog[data-cat-menu][open]')
      .forEach(function (open) { open.close(); });
    panel.showModal();
    /* showModal() focuses the first button — the close X — and Safari draws
       its focus ring on a plain tap. Focus the panel itself instead: focus
       still lands inside the dialog, and Tab reaches the X next. */
    var start = panel.firstElementChild;
    if (start) {
      start.setAttribute('tabindex', '-1');
      start.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-menu-open]')) {
      openPanel(mobileMenu);
      return;
    }

    /* Below 750px a nav label with a dropdown opens its panel rather than
       navigating — the panel leads with a "Shop all" button. Above it the
       label is an ordinary link and the mega menu opens on hover. */
    var catLink = event.target.closest('[data-cat-link]');
    if (catLink && !window.matchMedia('(min-width: 750px)').matches) {
      var catPanel = document.getElementById(catLink.dataset.catLink);
      if (catPanel) {
        event.preventDefault();
        openPanel(catPanel);
        return;
      }
    }

    if (event.target.closest('[data-menu-close], [data-cat-close]')) {
      var owner = event.target.closest('dialog');
      if (owner) owner.close();
      return;
    }

    /* Backdrop click (the dialog itself, outside the panel) closes */
    if (event.target.matches('dialog[data-mobile-menu], dialog[data-cat-menu]')) {
      event.target.close();
    }
  });

  /* A phone rotated to landscape can cross the breakpoint with a panel open,
     which would leave it stuck behind a CSS display:none. */
  window.matchMedia('(min-width: 750px)').addEventListener('change', function (event) {
    if (!event.matches) return;
    document.querySelectorAll('dialog[data-mobile-menu][open], dialog[data-cat-menu][open]')
      .forEach(function (open) { open.close(); });
  });

  /* Predictive search. The panel markup is rendered by sections/predictive-search
     via the Predictive Search API, so suggestions use the same money format,
     translations and image sizing as the rest of the theme. Submitting the form
     still works without JS — this only adds the suggestions. */
  document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('[data-predictive-results]');
    if (!input || !panel) return;

    var timer = null;
    var controller = null;
    var lastTerm = '';

    function hide() {
      panel.hidden = true;
      panel.innerHTML = '';
      lastTerm = '';
    }

    function activeLinks() {
      return Array.prototype.slice.call(panel.querySelectorAll('a'));
    }

    function move(step) {
      var links = activeLinks();
      if (!links.length) return;
      var index = links.findIndex(function (link) {
        return link.classList.contains('is-active');
      });
      links.forEach(function (link) { link.classList.remove('is-active'); });
      index = (index + step + links.length + 1) % (links.length + 1);
      if (index < links.length) {
        links[index].classList.add('is-active');
        links[index].scrollIntoView({ block: 'nearest' });
      }
    }

    function search(term) {
      /* Abort the in-flight request: without this a slow early keystroke can
         land after a fast later one and overwrite fresher suggestions. */
      if (controller) controller.abort();
      controller = new AbortController();

      fetch(
        '/search/suggest?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query&resources[limit]=6' +
          '&section_id=predictive-search',
        { signal: controller.signal }
      )
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var inner = parsed.querySelector('.predictive__inner');
          if (!inner) return hide();
          panel.innerHTML = inner.outerHTML;
          panel.hidden = false;
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') hide();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);

      if (term.length < 2) return hide();
      if (term === lastTerm) return;

      /* Debounced: one request per pause, not one per keystroke */
      timer = setTimeout(function () {
        lastTerm = term;
        search(term);
      }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
    });

    form.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        hide();
        return;
      }
      if (panel.hidden) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        move(event.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (event.key === 'Enter') {
        var active = panel.querySelector('a.is-active');
        if (active) {
          event.preventDefault();
          window.location.href = active.href;
        }
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) hide();
    });
  });

  /* Mega menu: keep panels usable on touch — first tap opens, second follows link.

     Only where the mega actually exists. Below 750px it is display:none and the
     caret button opens the full-screen category dialog instead, so swallowing
     the first tap there left the label dead: one tap did nothing, and only the
     second reached the collection. Matches the breakpoint in site-nav.liquid. */
  var megaIsShown = window.matchMedia('(min-width: 750px)');

  document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    trigger.addEventListener('touchend', function (event) {
      if (!megaIsShown.matches) return;

      var item = trigger.closest('[data-mega-item]');
      if (!item.classList.contains('is-open')) {
        event.preventDefault();
        document.querySelectorAll('[data-mega-item].is-open').forEach(function (other) {
          other.classList.remove('is-open');
        });
        item.classList.add('is-open');
      }
    });
  });

  document.addEventListener('touchend', function (event) {
    if (!event.target.closest('[data-mega-item]')) {
      document.querySelectorAll('[data-mega-item].is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    }
  });

  /* Hero carousel: scroll-snap track enhanced with arrows, dots and autoplay.
     Works without JS (native swipe); this just adds the controls. */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    var slides = track ? track.querySelectorAll('[data-hero-slide]') : [];
    if (!track || slides.length < 2) return;

    var dots = slider.querySelectorAll('[data-hero-dot]');
    var current = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) { dot.setAttribute('aria-selected', 'true'); } else { dot.removeAttribute('aria-selected'); }
      });
    }

    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.heroDot, 10)); });
    });

    /* Keep dots in sync with wherever the track actually is (swipe or button) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(Array.prototype.indexOf.call(slides, entry.target));
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (slide) { io.observe(slide); });
    }

    /* Autoplay — opt-in, pauses on hover/focus/off-screen, respects reduced motion */
    var interval = parseInt(slider.dataset.autoplay, 10) * 1000;
    if (interval && !reduce) {
      var timer = null;
      var play = function () { timer = setInterval(function () { goTo(current + 1); }, interval); };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', play);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', play);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { entry.isIntersecting ? play() : stop(); });
        }, { threshold: 0.3 }).observe(slider);
      } else {
        play();
      }
    }
  });

  /* Store locator: "find your nearest" over the cards the section already
     rendered. Nothing is ever fetched or built here — the lookup only reorders
     and hides existing cards, so the list stands on its own without JS. The
     search panel ships `hidden` and is revealed below, so a control that
     couldn't work is never shown. Geocoding is postcodes.io (free, UK, keyless). */
  document.querySelectorAll('[data-store-locator]').forEach(function (root) {
    var form = root.querySelector('[data-store-search]');
    var input = root.querySelector('[data-store-input]');
    var list = root.querySelector('[data-store-list]');
    var status = root.querySelector('[data-store-status]');
    var reset = root.querySelector('[data-store-reset]');
    var locate = root.querySelector('[data-store-locate]');
    var submit = form ? form.querySelector('[type="submit"]') : null;
    if (!form || !input || !list) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-store-card]'));
    if (!cards.length) return;

    var km = root.dataset.unit === 'km';
    var RADIUS = km ? 6371 : 3959;
    var UNIT = km ? 'km' : 'miles';
    /* A full UK postcode or just its outward half — "DE22 2QN" or "DE22" */
    var POSTCODE = /^[a-z]{1,2}\d[a-z\d]?\s*(\d[a-z]{2})?$/i;
    var API = 'https://api.postcodes.io';

    form.hidden = false;
    if (locate && !navigator.geolocation) locate.hidden = true;

    function say(message, isError) {
      status.textContent = message || '';
      if (isError) {
        status.setAttribute('data-state', 'error');
      } else {
        status.removeAttribute('data-state');
      }
    }

    function busy(on) {
      if (submit) submit.disabled = on;
      if (locate) locate.disabled = on;
    }

    /* postcodes.io answers 404 with a JSON body for an unknown postcode, so a
       miss and a network failure both land here as null. */
    function fetchJson(url, options) {
      return fetch(url, options)
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }

    function haversine(aLat, aLng, bLat, bLng) {
      var toRad = Math.PI / 180;
      var dLat = (bLat - aLat) * toRad;
      var dLng = (bLng - aLng) * toRad;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(aLat * toRad) * Math.cos(bLat * toRad) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return RADIUS * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
    }

    function tidy(postcode) {
      return String(postcode || '').toUpperCase().replace(/\s+/g, '');
    }

    /* Coordinates are optional in the editor, so any store that has only a
       postcode is geocoded once, in a single bulk call, and cached on the
       element via its dataset. */
    function ensureCoords() {
      var missing = cards.filter(function (card) {
        return !card.dataset.lat && card.dataset.postcode;
      });
      if (!missing.length) return Promise.resolve();

      return fetchJson(API + '/postcodes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          postcodes: missing.map(function (card) { return card.dataset.postcode; })
        })
      }).then(function (json) {
        if (!json || !json.result) return;
        var found = {};
        json.result.forEach(function (row) {
          if (row.result) found[tidy(row.query)] = row.result;
        });
        missing.forEach(function (card) {
          var hit = found[tidy(card.dataset.postcode)];
          if (hit) {
            card.dataset.lat = hit.latitude;
            card.dataset.lng = hit.longitude;
          }
        });
      });
    }

    function geocodePostcode(query) {
      var clean = tidy(query);
      return fetchJson(API + '/postcodes/' + encodeURIComponent(clean)).then(function (json) {
        if (json && json.result) {
          return { lat: json.result.latitude, lng: json.result.longitude, label: json.result.postcode };
        }
        /* Fall back to the outward code, so a half-remembered postcode — or a
           deliberate "DE22" — still places the shopper on the map. */
        var outcode = clean.length > 4 ? clean.slice(0, clean.length - 3) : clean;
        return fetchJson(API + '/outcodes/' + encodeURIComponent(outcode)).then(function (out) {
          if (out && out.result) {
            return { lat: out.result.latitude, lng: out.result.longitude, label: out.result.outcode };
          }
          return null;
        });
      });
    }

    function geocodePlace(query) {
      return fetchJson(API + '/places?limit=1&q=' + encodeURIComponent(query)).then(function (json) {
        var place = json && json.result && json.result[0];
        if (!place) return null;
        return { lat: place.latitude, lng: place.longitude, label: place.name_1 || query };
      });
    }

    function clearDistances() {
      cards.forEach(function (card) {
        var chip = card.querySelector('[data-store-distance]');
        if (chip) {
          chip.textContent = '';
          chip.hidden = true;
        }
        card.style.order = '';
      });
    }

    function showAll(message) {
      cards.forEach(function (card) { card.hidden = false; });
      clearDistances();
      if (reset) reset.hidden = true;
      say(message || '');
    }

    /* Floored at 0.1 so searching a store's own postcode reads "0.1 miles"
       rather than "0.0 miles", which looks like a failed calculation. */
    function format(distance) {
      var value = distance < 10 ? Math.max(distance, 0.1).toFixed(1) : Math.round(distance);
      return value + ' ' + UNIT;
    }

    function sortByDistance(origin) {
      var scored = cards.map(function (card) {
        var lat = parseFloat(card.dataset.lat);
        var lng = parseFloat(card.dataset.lng);
        var known = !isNaN(lat) && !isNaN(lng);
        return {
          card: card,
          distance: known ? haversine(origin.lat, origin.lng, lat, lng) : Infinity
        };
      });

      scored.sort(function (a, b) { return a.distance - b.distance; });

      scored.forEach(function (entry, index) {
        entry.card.hidden = false;
        /* `order` beats moving nodes: no reflow of focus, and it survives the
           editor re-rendering the section underneath us. */
        entry.card.style.order = index;
        var chip = entry.card.querySelector('[data-store-distance]');
        if (!chip) return;
        if (entry.distance === Infinity) {
          chip.textContent = '';
          chip.hidden = true;
        } else {
          chip.textContent = format(entry.distance);
          chip.hidden = false;
        }
      });

      if (reset) reset.hidden = false;

      var nearest = scored[0];
      var label = nearest.card.querySelector('[data-store-name]');
      if (nearest.distance === Infinity || !label) {
        say('Sorted by distance from ' + origin.label + '.');
      } else {
        say('Nearest to ' + origin.label + ' — ' + label.textContent.trim() +
          ', ' + format(nearest.distance) + ' away.');
      }
    }

    function textFilter(query) {
      var needle = query.toLowerCase();
      var matches = cards.filter(function (card) {
        return (card.dataset.haystack || '').indexOf(needle) !== -1;
      });
      if (!matches.length) return 0;

      clearDistances();
      cards.forEach(function (card) { card.hidden = matches.indexOf(card) === -1; });
      if (reset) reset.hidden = false;
      say(matches.length + (matches.length === 1 ? ' store matches “' : ' stores match “') + query + '”');
      return matches.length;
    }

    function search(query) {
      query = query.trim();
      if (!query) {
        showAll();
        return;
      }

      busy(true);
      say('Searching…');

      var lookup;
      if (POSTCODE.test(query)) {
        lookup = ensureCoords().then(function () { return geocodePostcode(query); });
      } else if (textFilter(query)) {
        busy(false);
        return;
      } else {
        /* No name or address matched, so try the query as a place — "Chester"
           should give a nearest store, not a dead end. */
        lookup = ensureCoords().then(function () { return geocodePlace(query); });
      }

      lookup.then(function (origin) {
        busy(false);
        if (origin) {
          sortByDistance(origin);
        } else {
          cards.forEach(function (card) { card.hidden = false; });
          clearDistances();
          if (reset) reset.hidden = true;
          say('We couldn’t find “' + query + '”. Try a UK postcode or a town name.', true);
        }
      }).catch(function () {
        busy(false);
        showAll();
        say('The lookup is unavailable right now — all our stores are listed below.', true);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      search(input.value);
    });

    /* Clearing the field (including the native ✕ on a search input) restores
       the full list without needing the reset button. */
    input.addEventListener('input', function () {
      if (!input.value.trim()) showAll();
    });

    if (reset) {
      reset.addEventListener('click', function () {
        input.value = '';
        showAll();
        input.focus();
      });
    }

    if (locate) {
      locate.addEventListener('click', function () {
        busy(true);
        say('Finding your location…');
        navigator.geolocation.getCurrentPosition(function (position) {
          input.value = '';
          ensureCoords().then(function () {
            busy(false);
            sortByDistance({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              label: 'you'
            });
          });
        }, function () {
          busy(false);
          say('We couldn’t get your location. Try typing a postcode instead.', true);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    }
  });
})();
